import { TYPE_PAGE_LIMIT } from 'constants/search'
import { SORTBY_VERTICAL_CRUISE } from 'constants/offerList'
import Places from './places'

export const CRUISE_LOCATION_SEARCH_TYPEAHEAD_TYPES: Array<App.SearchPlaceType> = [
  'city',
  'colloquial_area',
  'continent',
  'country',
  'high_level_region',
  'multi_city_vicinity',
  'province_state',
]
export const CRUISE_DEPARTURE_SEARCH_TYPEAHEAD_TYPES: Array<App.SearchPlaceType> = ['city']
export const CRUISE_DESTINATION_SEARCH_TYPES: Array<App.SearchType> = ['destination']
export const CRUISE_DEPARTURE_SEARCH_TYPES: Array<App.SearchType> = ['destination']
export const CRUISE_SEARCH_HERO_IMAGE_ID_DESKTOP = '2026-cruise-vertical-landscape'
export const CRUISE_SEARCH_HERO_IMAGE_ID_MOBILE = '2026-cruise-vertical-portrait'
export const CRUISE_DEALS_LIST_PAGE_HERO_IMAGE_ID = 'acee87eb-2922-4881-9799-3658cc046dcb'
export const CRUISE_OFFER_TYPES: Array<App.OfferType> = ['cruise']
export const CRUISE_SESSION_EXPIRATION_TIME_IN_MINUTES = 15
export const CRUISE_SEARCH_HERO_VIDEO_URL = 'https://player.vimeo.com/progressive_redirect/playback/796859202/rendition/1080p/file.mp4?loc=external&signature=140b579e292110b350a75b3a823ec915e644a3696c6229cb8d41347b6d8fd9c1'
/**
 * @deprecated Use `useCruiseSearchLabels` from `hooks/Cruise/useCruiseSearchLabels` for localized hero bar destinations in React components.
 */
export const CRUISE_SEARCH_HERO_BAR_DESTINATIONS = ['the Caribbean', 'Europe', 'the Mediterranean', 'Asia', 'Barcelona']
export const CRUISE_OFFER_TYPE: App.Cruises.CruiseOfferType = 'cruise'
export const CRUISE_FLASH_OFFER_TYPE: App.Cruises.CruiseFlashOfferType = 'cruise_tour'
export const CRUISE_FLASH_OFFER_V1_TYPE: App.Cruises.CruiseFlashOfferV1Type = 'tour'
export const CRUISE_LEGACY_OFFER_HOTEL_TYPE: App.Cruises.CruiseLegacyOfferHotelType = 'hotel'

export enum CruiseSectionTabValues {
  DATES_PRICING = 'DATES_PRICING',
  ITINERARY = 'ITINERARY',
  ABOUT_SHIP = 'ABOUT_SHIP',
  FAQ = 'FAQ',
  FINE_PRINT = 'FINE_PRINT',
}

export enum CruiseContentSections {
  GALLERY = 'gallery',
  OVERVIEW = 'overview',
  ITINERARY = 'itinerary',
  ABOUT_THE_SHIP = 'about-the-ship',
  // INCLUSIONS = 'inclusions',
  DEPARTURES = 'dates-and-pricing',
  DECKS_AND_CABINS = 'decks-and-cabins',
  FINE_PRINT = 'things-to-know',
  FAQ = 'frequently-asked-questions',
}

export enum CruiseType {
  OCEAN = 'OCEAN',
  RIVER = 'RIVER',
}

export const CRUISE_OFFER_DUE_DATE_DAY_THRESHOLD = 90

export const CABIN_CATEGORIES: Array<App.Cruises.CabinCategory> = [
  { category: 'Inside', filter: 'Lowest Inside Price', defaultImageId: '6cxshzr6hfv7a0p5v1a' },
  { category: 'Oceanview', filter: 'Lowest Oceanview Price', defaultImageId: 'k4k2dg9n17f9khvoj19' },
  { category: 'Balcony', filter: 'Lowest Balcony Price', defaultImageId: 'lx75o348zmq1w0tsz3nig' },
  { category: 'Suite', filter: 'Lowest Suite Price', defaultImageId: '812wqcsgf6ysfozdbngl' },
]

export const CABIN_CATEGORIES_RIVER: Array<App.Cruises.CabinCategory> = [
  { category: 'Window', filter: 'Lowest Window Price', defaultImageId: 'cdc07f17-2170-419d-a286-276c302436ea' },
  { category: 'Balcony', filter: 'Lowest Balcony Price', defaultImageId: 'lx75o348zmq1w0tsz3nig' },
  { category: 'Suite', filter: 'Lowest Suite Price', defaultImageId: '812wqcsgf6ysfozdbngl' },
]

export type CABIN_CATEGORY_TYPE = 'Inside' | 'Oceanview' | 'Balcony' | 'Suite'

export const CABIN_CATEGORIES_SORT_ORDER: Array<CABIN_CATEGORY_TYPE> = ['Inside', 'Oceanview', 'Balcony', 'Suite']

/**
 * @deprecated Use `useCruiseSearchLabels` from `hooks/Cruise/useCruiseSearchLabels` for localized cabin descriptions in React components.
 */
export const CABIN_CATEGORY_DESCRIPTIONS: Record<string, string> = {
  Inside: 'An inside cabin is normally the most affordable option, often without a window.',
  Oceanview: 'An oceanview cabin, often called an outside cabin, is a room with a port hole or window that looks out to sea, depending on deck and location.',
  Window: 'A window cabin is a room with a fixed picture window that looks onto the river and passing scenery, depending on deck and location.',
  'Oceanview / Window': 'An oceanview / window cabin is a room with a port hole or window that looks out to sea or river and passing scenery, depending on deck and location.',
  Balcony: 'A balcony cabin is any cruise room with a private verandah, allowing you to take in the beautiful views and fresh air.',
  Suite: 'A suite is an especially large room within a cruise ship’s top tier of cabins, often with a wide window and/or private verandah.',
}

export const CRUISE_MOCK_PRICES = [
  {
    marketName: 'Australia',
    currencyCode: 'AUD',
    categoryCode: 'GS',
    rateCode: 'T',
    adultFare: 2609.32,
    nccf: 153.68,
    isNccfIncluded: false,
    tax: 162.89,
    isTaxIncluded: false,
    cabinCategory: 'Suite',
  },
  {
    marketName: 'Australia',
    currencyCode: 'AUD',
    categoryCode: 'OV',
    rateCode: 'T',
    adultFare: 1447.32,
    nccf: 153.68,
    isNccfIncluded: false,
    tax: 162.89,
    isTaxIncluded: false,
    cabinCategory: 'Oceanview',
  },
  {
    marketName: 'Australia',
    currencyCode: 'AUD',
    categoryCode: '4C',
    rateCode: 'PB4',
    adultFare: 1459.32,
    nccf: 153.68,
    isNccfIncluded: false,
    tax: 162.89,
    isTaxIncluded: false,
    cabinCategory: 'Balcony',
  },
  {
    marketName: 'Australia',
    currencyCode: 'AUD',
    categoryCode: '1A',
    rateCode: 'PB4',
    adultFare: 439.32,
    nccf: 153.68,
    isNccfIncluded: false,
    tax: 162.89,
    isTaxIncluded: false,
    cabinCategory: 'Inside',
    cabinPriceDesc: 'Lowest Inside Price',
  },
]

// TODO it will be replaced by API data
export const SEARCH_DEPARTURE_PORTS: Array<App.SearchItem> = [
  {
    searchType: 'destination',
    value: Places.Anywhere.id,
    format: {
      mainText: 'All departure ports',
    },
  },
  {
    searchType: 'departurePort',
    value: 'le_678c61ac5b4f91ca86e112fc50e63766',
    format: {
      mainText: 'Sydney',
    },
  },
  {
    searchType: 'departurePort',
    value: 'le_ce393994e8cf430867408678d1a5a9c8',
    format: {
      mainText: 'Singapore',
    },
  },
  {
    searchType: 'departurePort',
    value: 'le_af15ce7cbd279b1a769d85d1540a5073',
    format: {
      mainText: 'Barcelona',
    },
  },
  {
    searchType: 'departurePort',
    value: 'le_39c4c0a45681f21cead1b7004d1a67ce',
    format: {
      mainText: 'Seattle',
    },
  },
  {
    searchType: 'departurePort',
    value: 'le_342fdc93f26b8bb8fe3548a9188ea5d2',
    format: {
      mainText: 'Athens',
    },
  },
]

export const CruiseSearchFilterKeys = [
  'cruiseShips',
  'promotions',
  'isLuxExclusivePromotion',
  'isSpecialOffers',
  'isLuxPlus',
  'price.min',
  'price.max',
  'cruiseTypes',
  'cabinTypes',
]

export const LANDING_PAGE_AVAILABLE = [
  'Royal Caribbean International',
  'Holland America Line',
  'Celebrity Cruises',
  'P&O Cruises Australia',
  'Silversea Cruises',
  'Princess Cruises',
  'MSC Cruises',
]

/**
 * @deprecated Use `useCruiseSearchLabels` from `hooks/Cruise/useCruiseSearchLabels` for localized error messages in React components.
 */
export const CRUISE_CHECKOUT_ERRORS = [
  'Invalid email',
]

export const CRUISE_LEGACY_FILTERS: App.OfferListFilters = {
  holidayTypes: ['Cruises'], // Only include offers that have Cruises holiday type
  offerTypes: [
    CRUISE_FLASH_OFFER_V1_TYPE,
    CRUISE_LEGACY_OFFER_HOTEL_TYPE,
  ], // This is to include cruises that are set up as flash hotel offers (e.g. Disney Cruise)
}

export const CRUISE_UNIFIED_FILTERS: App.OfferListFilters = {
  holidayTypes: ['Cruises'],
  offerTypes: [
    CRUISE_OFFER_TYPE,
    CRUISE_FLASH_OFFER_TYPE,
    CRUISE_FLASH_OFFER_V1_TYPE,
    CRUISE_LEGACY_OFFER_HOTEL_TYPE,
  ],
  sortBy: SORTBY_VERTICAL_CRUISE,
  limit: TYPE_PAGE_LIMIT,
}

export const CRUISE_BANK_OFFERS_FILTERS: App.OfferListFilters = {
  offerTypes: [CRUISE_OFFER_TYPE],
  limit: TYPE_PAGE_LIMIT,
}

export const CRUISE_FLASH_OFFERS_FILTERS: App.OfferListFilters = {
  holidayTypes: ['Cruises'],
  offerTypes: [CRUISE_FLASH_OFFER_V1_TYPE, CRUISE_LEGACY_OFFER_HOTEL_TYPE],
  sortBy: SORTBY_VERTICAL_CRUISE,
  limit: TYPE_PAGE_LIMIT,
}

export const CRUISE_DESTINATION_PILLS = [
  { destinationName: 'Australia', destinationId: 'le_d3d9446802a44259755d38e6d163e820' },
  { destinationName: 'New Zealand', destinationId: 'le_9fc3d7152ba9336a670e36d0ed79bc43' },
  { destinationName: 'South Pacific', destinationId: 'le_a8697c7e6e7988b29a9de094b8d554cc' },
  { destinationName: 'Caribbean', destinationId: 'le_d7bce4d8dbac13945471c343c4973ba3' },
  { destinationName: 'Spain', destinationId: 'le_7e7757b1e12abcb736ab9a754ffb617a' },
  { destinationName: 'Greece', destinationId: 'le_735b90b4568125ed6c3f678819b6e058' },
  { destinationName: 'United States of America', urlName: 'United States of America', destinationId: 'le_757b505cfd34c64c85ca5b5690ee5293' },
]

// TODO: Remove the hardcoded vendor images - https://aussiecommerce.atlassian.net/browse/CRUZ-3104
export const CRUISE_LINE_CUSTOM_INFO = [
  { imageIdSm: 'en19l8ff1fhgec0k207', code: 'AZA' },
  { imageIdSm: 'x6b5w2dw9ihw8i5nu3kzt', code: 'CCL' },
  { imageIdSm: '29c4x6qlv72pdskxtuv', code: 'CEL' },
  { imageIdSm: 'fvzy8xe3zd1xtfiricim', code: 'CEX' },
  { imageIdSm: 'a4she3m3ztzpyvywg2un', code: 'CUN' },
  { imageIdSm: '0tewxh58wsfrur3gjj6', code: 'DCL' },
  { imageIdSm: 'bgrxlvu0d7eizy0cv06', code: 'EXJ' },
  { imageIdSm: '4s07r07b7tvwk8d8uav', code: 'HAL' },
  { imageIdSm: 'l3x4e3rmivugao9lp26m', code: 'MSC' },
  { imageIdSm: 'wyhk47lmzz096q98z6c', code: 'NCL' },
  { imageIdSm: 'tglbrhr4ue6puozki4k', code: 'OCL' },
  { imageIdSm: '4fp27ca9yvkuo9iajbc', code: 'PCL' },
  { imageIdSm: 'qjj296o519z21yc4o8yg', code: 'POA' },
  { imageIdSm: 'nenrq88hvwo2ouxdk8rf', code: 'RCC', name: 'Royal Caribbean' },
  { imageIdSm: 'p528tdrhgd8q68cf1c3', code: 'RDC', name: 'Regent Seven Seas' },
  { imageIdSm: 'xhdkxgy1xlumco336f', code: 'SBN' },
  { imageIdSm: 'i0mabf1aai5pnyzmvn', code: 'VVG' },
  { imageIdSm: 'xm94y5k2rfnvovolvq3w', code: 'SRX' },
  { imageIdSm: 'h0qxc9dhrldrkeyyf4be', code: 'HEX' },
  { imageIdSm: 'c228d2bc-9ee8-4d57-9152-b694d2d3ed25', code: 'CRS' },
  { imageIdSm: 'bd7adbfa-81ef-4a10-952b-931be6116cda', code: 'LCL' },
  { imageIdSm: 'cke43d5nf5kdem4fzop', code: 'VOC' },
  { imageIdSm: '2376536e-f6c5-4eff-a8ba-cde954d7d47c', code: 'URC' },
  { imageIdSm: 'dtjaokoqy9t4ziw25x8', code: 'AWW' },
  { imageIdSm: '29c4x6qlv72pdskxtuv', code: 'CER' },
  { imageIdSm: 'gmn0nhvd4q6pu05xguq', code: 'VRX' },
  // flash offer cruise lines
  { imageIdSm: 'nenrq88hvwo2ouxdk8rf', code: 'Royal Caribbean International', name: 'Royal Caribbean' },
  { imageIdSm: 'w1zodchyrgyd4ri92f3f', code: 'Riverside Luxury Cruises' },
  { imageIdSm: '29c4x6qlv72pdskxtuv', code: 'Celebrity Cruises' },
  { imageIdSm: '2nsxgnhd0b0bm1k12a1v', code: 'Coral Expeditions' },
  { imageIdSm: 'ejvx4zaw3n52xaxjwcan', code: 'Heritage Expeditions' },
]

export const CRUISE_LINE_INFO = {
  AWW: {
    dealPageImageId: 'rke2ktooi9zrhomuofb',
    dealPageColour: '#B34E3C',
    finePrintLink: 'https://www.amawaterways.au/terms-conditions',
  },
  AZA: {
    dealPageImageId: 'vhq1kat09swfmb8zckv',
    dealPageColour: '#2A758C',
    finePrintLink: 'https://www.azamara.com/au/booked-guests/before-you-board/payment-cancellation',
  },
  CCL: {
    dealPageImageId: 'vhq1kat09swfmb8zckv',
    dealPageColour: '#3A4EA9',
    finePrintLink: 'https://www.carnival.com/about-carnival/legal-notice/termsandconditions',
  },
  CEL: {
    dealPageImageId: 'vhq1kat09swfmb8zckv',
    dealPageColour: '#0B3A5F',
    finePrintLink: 'https://www.celebritycruises.com/guest-terms/',
  },
  CEX: {
    dealPageImageId: 'vhq1kat09swfmb8zckv',
    dealPageColour: '#23305C',
    finePrintLink: 'https://luxuryescapes.com/au/booking-policies#cruises',
  },
  CRS: {
    dealPageImageId: '2l3ns8o8pqd81y7b7o6b',
    dealPageColour: '#0B8F97',
    finePrintLink: 'https://www.crystalcruises.com/legal/booking-terms-conditions',
  },
  CUN: {
    dealPageImageId: 'vhq1kat09swfmb8zckv',
    dealPageColour: '#843A46',
    finePrintLink: 'https://www.cunard.com/content/dam/cunard/marketing-assets/pdf/booking-condition-pdf/22052_Cunard%20Brochure%202023-24_Booking%20Conditions_DPS.pdf',
  },
  DCL: {
    dealPageImageId: 'uqsst6n78qh6cm53fag',
    dealPageColour: '#A65153',
    finePrintLink: 'https://disneycruise.disney.go.com/contracts-terms-safety/terms-conditions/australia-new-zealand/',
  },
  EXJ: {
    dealPageImageId: 'vhq1kat09swfmb8zckv',
    dealPageColour: '#856856',
    finePrintLink: 'https://explorajourneys.com/au/en/legal/booking-terms-and-conditions',
  },
  HAL: {
    dealPageImageId: 'vhq1kat09swfmb8zckv',
    dealPageColour: '#133D6C',
    finePrintLink: 'https://www.hollandamerica.com/en/legal-privacy/cruise-contract',
  },
  LCL: {
    dealPageImageId: 'ocgyxhd8ie8s5fbi6qrq',
    dealPageColour: '#022572',
    finePrintLink: 'https://celestyal.com/terms-and-conditions/booking-conditions',
  },
  MSC: {
    dealPageImageId: 'vhq1kat09swfmb8zckv',
    dealPageColour: '#091330',
    finePrintLink: 'https://www.msccruises.com.au/terms-conditions',
  },
  NCL: {
    dealPageImageId: '41999qr5nijy8peoowsb',
    dealPageColour: '#3D78A6',
    finePrintLink: 'https://www.ncl.com/about/terms-and-conditions-au',
  },
  OCL: {
    dealPageImageId: 'vhq1kat09swfmb8zckv',
    dealPageColour: '#007BC3',
    finePrintLink: 'https://www.oceaniacruises.com/legal',
  },
  PCL: {
    dealPageImageId: 'zl930hjir5ftsfo4bq9',
    dealPageColour: '#22539F',
    finePrintLink: 'https://www.princess.com/en-int/legal/passage-contract',
  },
  RCC: {
    dealPageImageId: 'rlj9duk389lbgI7m1wt',
    dealPageColour: '#23305C',
    finePrintLink: 'https://www.royalcaribbean.com/guest-terms/',
  },
  RDC: {
    dealPageImageId: 'vhq1kat09swfmb8zckv',
    dealPageColour: '#363A45',
    finePrintLink: 'https://luxuryescapes.com/au/booking-policies#cruises',
  },
  SBN: {
    dealPageImageId: 'c95uaj6gcs0im2a6m8vm',
    dealPageColour: '#9D8C50',
    finePrintLink: 'https://www.seabourn.com/en/legal-privacy/cruise-contract',
  },
  VVG: {
    dealPageImageId: 'vhq1kat09swfmb8zckv',
    dealPageColour: '#760504',
    finePrintLink: 'https://www.virginvoyages.com/addl-terms-and-conditions',
  },
  SRX: {
    dealPageImageId: 'fn03fsdp8w7est4h62u',
    dealPageColour: '#4E5560',
    finePrintLink: 'https://www.silversea.com/terms-and-conditions.html',
  },
  URC: {
    dealPageImageId: 'tjbk470qg2yfjr5rvsn',
    dealPageColour: '#3B5998',
    finePrintLink: 'https://www.uniworld.com/au/terms-and-conditions',
  },
  VOC: {
    dealPageImageId: 'zbvb1v1j7wb5blh02b',
    dealPageColour: '#241F21',
    finePrintLink: 'https://www.vikingcruises.com.au/legal',
  },
  VRX: {
    dealPageImageId: 'o35itp7gl9xizeu7r8x',
    dealPageColour: '#241F21',
    finePrintLink: 'https://www.vikingcruises.com.au/legal',
  },
}

export const DEFAULT_CRUISE_LINE_DEALS_PAGE_INFO = CRUISE_LINE_INFO.CEL

export const SKIP_STEP_FOR_CABIN_TYPES = ['Suite']

export const CRUISE_ROUTES = {
  SEARCH_PAGE: '/search/cruises',
}

export const DEFAULT_CRUISE_LINE_FINE_PRINT_LINK = 'https://luxuryescapes.com/au/booking-policies#cruises'

export const CRUISE_AMENITY_CATEGORIES_REGEX = {
  FOOD: /food|buffet/,
  DINING: /dining|restaurant|cuisine|wine|cafe/,
  ENTERTAINMENT: /entertainment|show|nightlife|club|theater|music|movie|performance/,
  WELLNESS: /spa|wellness|health|relax|fitness|gym/,
  FAMILY: /kids|teens|family|youth|children/,
  ACTIVITIES: /activity|activities|adventure|recreation|sports|pool|water|swim|game|fun|arcade/,
  BARS: /bar|lounge|cocktail|drinks|pub/,
  SHOPPING: /shop|shopping|boutique|gallery|store/,
  TECHNOLOGY: /technology|tech|innovation/,
  ACCOMMODATION: /suite|stateroom|room|cabin/,
  ENRICHMENT: /enrich|educa|lecture|course/,
  SPECIFICATIONS: /ship fact|specification|tonnage|length|crew|passenger capacity|speed/,
  SERVICES: /service|staff|personal|butler|concierge/,
  PUBLIC_AREAS: /public area|common area|reception|atrium|lobby/,
  OTHER: /other/,
}
